


export const pageTitle = (newTitle) => {
    return (document.title = newTitle);
}